import React from 'react';
import { pinnedProvinces, placeholders } from "../../Common/Constants";
import { SearchComponentV2 } from "../../Common/SearchComponentV2";
var ProvinceOfResidenceQuestionContent = function ProvinceOfResidenceQuestionContent(props) {
  var setField = props.setField,
    stateOfResidence = props.stateOfResidence,
    errorMessage = props.errorMessage,
    provincesData = props.provincesData,
    setErrorMessage = props.setErrorMessage;
  var clearError = function clearError() {
    setErrorMessage('');
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchComponentV2, {
    keyName: "stateOfResidence",
    clearError: clearError,
    errorMessage: errorMessage,
    items: provincesData,
    pinnedItems: pinnedProvinces,
    placeholder: placeholders.state,
    field: stateOfResidence,
    setField: setField
  }));
};
export default ProvinceOfResidenceQuestionContent;